var n = ["children", "lifeCycle", "ref"];

function t(t, e, o, i) {
  void 0 === e && (e = !0), void 0 === o && (o = []), void 0 === i && (i = []);

  for (var r = {}, c = Object.keys(t), u = function u(_u) {
    var f = c[_u],
        s = t[f],
        v = n.some(function (n) {
      return n === f;
    });
    return "extraOptions" === f ? (Object.assign(r, s), "continue") : v || i.includes(f) || e && /^on[A-Z]/.test(f) && "function" == typeof s && !o.includes(f) ? "continue" : void (r[f] = s);
  }, f = 0; f < c.length; ++f) {
    u(f);
  }

  return r;
}

function e(n, t, e, o) {
  var i;
  "function" == typeof n[e] ? n[e](o) : "function" == typeof n.setOptions && n.setOptions(((i = {})[t] = o, i));
}

function o(n) {
  return function (t, e) {
    var o;
    t.setOptions(((o = {})[n] = e, o));
  };
}

export { t as getInitialOptionsFromProps, o as makeOptionsSetter, e as setValueOrSetOption };